import { Link } from "react-router-dom";
import { VisaType, VisaTypeLabels } from "../API/visaEligibilityAPI";

// Design tokens: card descriptions for mock alignment (API has id + name only)
const SERVICE_DESCRIPTIONS: Record<string, string> = {
  "I-90":
    "I-90, Application to Replace Permanent Resident Card (Green Card)",
  "I-751":
    "I-751, Petition to Remove Conditions on Residence",
  "I-131":
    "I-131, Application for Travel Documents, Parole Documents, and Arrival/Departure Records",
  "N-400":
    "Application for U.S. Citizenship through Naturalization (Form N-400)",
  "I-130":
    "Petition to Help a Family Member Immigrate to the U.S. (Form I-130)",
};

const SERVICE_TITLES: Record<string, string> = {
  "I-90": "Green Card Renewal/Replacement",
  "I-751": "Green Card Conditions Removal",
  "I-131": "Travel Document Application",
  "N-400": "Citizenship Application",
  "I-130": "Family Sponsorship",
};

const SERVICES_LIST = Object.values(VisaType).map((code) => ({
  code,
  title: SERVICE_TITLES[code] || code,
  description:
    SERVICE_DESCRIPTIONS[code] ||
    (VisaTypeLabels as Record<string, string>)[code] ||
    "",
}));

const cardStyle = {
  background: "hsla(0, 0%, 100%, 1)",
  boxShadow: "0px 13px 100px 0px hsla(0, 0%, 78%, 0.25)",
  borderRadius: 16,
  padding: 24,
  gap: 16,
  flex: "1 1 320px",
  minWidth: 320,
  minHeight: 242,
  display: "flex",
  flexDirection: "column" as const,
  alignItems: "flex-start",
  textDecoration: "none",
  color: "inherit",
  transition: "box-shadow 0.2s ease, transform 0.2s ease",
};

const badgeStyle = {
  background: "hsla(27, 87%, 67%, 1)",
  color: "#fff",
  fontFamily: "Nunito, sans-serif",
  fontWeight: 600,
  fontSize: 14,
  padding: "6px 12px",
  borderRadius: 9999,
};

const titleStyle = {
  fontFamily: "Nunito, sans-serif",
  fontWeight: 700,
  fontSize: 24,
  lineHeight: "40px",
  letterSpacing: "-0.32px",
  color: "#1B365D",
  margin: 0,
};

const subtitleStyle = {
  fontFamily: "Nunito, sans-serif",
  fontWeight: 400,
  fontSize: 16,
  lineHeight: "28px",
  letterSpacing: 0,
  color: "#5F6368",
  margin: 0,
};

// Page title "Choose Your Service" – design tokens
const pageTitleStyle = {
  fontFamily: "Georgia, serif",
  fontWeight: 400,
  fontStyle: "normal",
  fontSize: 34,
  lineHeight: "48px",
  letterSpacing: 0,
  color: "#1B365D",
  margin: 0,
};

// Page subtitle "Start new Application" – design tokens
const pageSubtitleStyle = {
  fontFamily: "Nunito, sans-serif",
  fontWeight: 400,
  fontStyle: "normal",
  fontSize: 18,
  lineHeight: "18px",
  letterSpacing: 0,
  color: "#5F6368",
};

const ChooseService = () => {
  return (
    <div className="page_main page_main-after-login mt-[100px] pt-[40px] bg-[#F7F8FA] min-h-screen">
      <div className="container mx-auto">
        <div className="mb-8">
          <h1 style={pageTitleStyle}>
            Choose Your Service
          </h1>
          <p style={pageSubtitleStyle}>
            Start New Application
          </p>
        </div>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 24,
          }}
        >
          {SERVICES_LIST.map((service) => (
            <Link
              key={service.code}
              to={`/visa-eligibility/${service.code}`}
              style={cardStyle}
              className="hover:shadow-xl hover:-translate-y-0.5"
            >
              <span style={badgeStyle}>{service.code}</span>
              <h2 style={titleStyle}>{service.title}</h2>
              <p style={subtitleStyle}>{service.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChooseService;
